<template>
  <roe-error-message
    v-if="isContributionAmount"
    :field="tier.contribution_amount"
  >
    <input
      type="number"
      v-model="tier.$model.contribution_amount"
      required
      tabindex="2"
    />
    <label class="input-label-inside">$</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeTierContributionAmountInput",
  components: { RoeErrorMessage },
  props: {
    tier: Object,
    isContributionAmount: Boolean
  }
};
</script>
